module.exports = __webpack_public_path__ + "img/check_ing.66c4278d.png";